import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryParams } from '@/@diffrag/hooks/useQueryParams'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { OffsetPagination } from '@/@diffrag/OffsetPagination'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { TableFormatter } from '@/@diffrag/table/TableFormatter'
import { api } from '@/api'
import { IAdminQnaRoInquiryStatusEnum } from 'api'
import { useNavigate } from 'react-router-dom'

export default function Qna() {
  const page = useQueryValue('page', 1)
  const q = useQueryValue('q', undefined)
  const navigate = useNavigate()
  const status = useQueryValue('status', undefined)

  const { data, isFetching } = useApi({
    id: 'qnaList',
    fn: api().admin.getQnaList,
    params: {
      page,
      pageSize: 20,
      q,
      status,
    },
  })
  return (
    <ContentView>
      <SimpleTable
        isLoading={isFetching}
        options={{
          disableNew: true,
          disableSelect: true,
          disableSort: true,
        }}
        onRowClick={(row) => {
          navigate(`/qna/detail?id=${row.id}`)
        }}
        filters={[
          {
            label:
              {
                [IAdminQnaRoInquiryStatusEnum.WAITING]: '답변대기',
                [IAdminQnaRoInquiryStatusEnum.ANSWERED]: '답변완료',
              }[status as IAdminQnaRoInquiryStatusEnum] ?? '전체',
            key: 'status',
            items: [
              {
                label: '전체',
                value: undefined,
              },
              {
                label: '답변대기',
                value: IAdminQnaRoInquiryStatusEnum.WAITING,
              },
              {
                label: '답변완료',
                value: IAdminQnaRoInquiryStatusEnum.ANSWERED,
              },
            ],
          },
        ]}
        data={data?.rows}
        columns={[
          {
            key: 'id',
            label: 'NO',
            isPrimary: true,
          },
          {
            key: 'author.userData.nickname',
            label: '작성자',
            isPrimary: true,
          },
          {
            label: '문의 제목',
            key: 'title',
            isPrimary: true,
          },
          {
            label: '작성일',
            key: 'createDate',
            formatter: TableFormatter.datetime(),
          },
          {
            label: '상태',
            key: 'inquiryStatus',
            valueMap: {
              WAITING: '답변대기',
              ANSWERED: '답변완료',
            },
          },
        ]}
      />
      <OffsetPagination page={page} total={data?.count} pageSize={20} />
    </ContentView>
  )
}
